"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

// taken from https://github.com/sindresorhus/array-move
// but added here so it will be compiled to es5 as the original library was not nad failed iin IE11
var arrayMoveMutate = function arrayMoveMutate(array, from, to) {
  var startIndex = to < 0 ? array.length + to : to;
  var item = array.splice(from, 1)[0];
  array.splice(startIndex, 0, item);
};

var arrayMove = function arrayMove(array, from, to) {
  var newArray = (0, _toConsumableArray2.default)(array);
  arrayMoveMutate(newArray, from, to);
  return newArray;
};

var _default = arrayMove;
exports.default = _default;